(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function setupHeader() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      menu.classList.toggle('is-open', !isOpen);
      document.body.classList.toggle('nav-open', !isOpen);
    });
  }

  function getCheckedValue(root, key) {
    var input = root.querySelector('[data-config-input="' + key + '"]:checked');
    return input ? input.value : '';
  }

  function getCheckedValues(root, key) {
    return Array.prototype.slice
      .call(root.querySelectorAll('[data-config-input="' + key + '"]:checked'))
      .map(function (input) {
        return input.value;
      });
  }

  function getValue(root, key) {
    var input = root.querySelector('[data-config-input="' + key + '"]');
    return input ? input.value.trim() : '';
  }

  function euro(value) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(value);
  }

  function euroPerPerson(value) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  function normalize(value) {
    return String(value || '').toLowerCase();
  }

  function normalizeChoice(value) {
    return normalize(value)
      .replace(/&/g, 'en')
      .replace(/\+/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function canonicalConcept(value) {
    var key = normalizeChoice(value);
    var aliases = {
      'loaded fries': 'Loaded Fries Bar',
      'loaded fries bar': 'Loaded Fries Bar',
      'budget friet snack basis': 'Budget friet/snack basis',
      'friet snack basis': 'Budget friet/snack basis',
      'budget frietje': 'Budget friet/snack basis',
      'smash burger': 'Smashburgers',
      'smash burgers': 'Smashburgers',
      'smashburgers': 'Smashburgers',
      'asian': 'Asian Streetfood',
      'asian streetfood': 'Asian Streetfood',
      'juice': 'Juice & Smoothie Bar',
      'smoothie': 'Juice & Smoothie Bar',
      'juice smoothie bar': 'Juice & Smoothie Bar',
      'juice en smoothie bar': 'Juice & Smoothie Bar',
      'event specials': 'Premium event menu',
      'premium uitbreidingen': 'Premium event menu',
      'event specials premium uitbreidingen': 'Premium event menu',
      'premium event menu': 'Premium event menu',
      'mix match': 'Mix & Match',
      'mix en match': 'Mix & Match',
      'wij denken mee': 'Wij denken mee',
      'adviseer mij': 'Wij denken mee',
      'advies': 'Wij denken mee'
    };
    return aliases[key] || value;
  }

  function roundUp(value, step) {
    return Math.ceil(value / step) * step;
  }

  function formatPriceParts(price) {
    var parts = [];
    if (price.pp) parts.push('+' + euroPerPerson(price.pp) + ' p.p.');
    if (price.fixed) parts.push('+' + euro(price.fixed));
    return parts.join(' ');
  }

  function calculateEstimate(state) {
    var guests = Math.max(Number(state.guests || 0), 0);
    var eventType = normalize(state.eventType);
    var serviceKey = normalize(state.service);
    var packageKey = normalize(state.packageLevel);
    var lines = [];
    var notes = [];
    var eventAdditions = [];
    if (state.karaokeMode && state.karaokeMode !== 'Geen karaoke') eventAdditions.push('Karaoke (' + state.karaokeMode + ')');
    (state.eventModules || []).forEach(function (module) { eventAdditions.push(module); });
    if (state.requestScope === 'Alleen karaoke') {
      return {
        label: 'Karaokeprijs op aanvraag',
        detail: 'Geen catering geselecteerd. We prijzen de karaoke, het tijdvak en eventuele techniek apart.',
        lines: eventAdditions.map(function (item) { return item + ': op aanvraag'; }),
        note: 'Je ontvangt vooraf een volledige offerte, inclusief afspraken over de set, begeleiding, opbouw, afbouw en eventuele extra kosten.',
        hidden: 'Alleen karaoke: prijs op aanvraag. ' + eventAdditions.join(', ') + '. Geen cateringkosten berekend.'
      };
    }

    var packages = {
      'budget/basic': { label: 'Budget/basic', pp: 6.95, minimum: 295 },
      'standard': { label: 'Standard', pp: 9.95, minimum: 525 },
      'premium': { label: 'Premium', pp: 14.95, minimum: 850 },
      'custom': { label: 'Custom', pp: 11.95, minimum: 650 }
    };

    var services = {
      'foodtruck op locatie': { label: 'Foodtruck op locatie', fixed: 75, pp: 0 },
      'uitgiftebar naast foodtruck': { label: 'Uitgiftebar naast foodtruck', fixed: 125, pp: 0.5 },
      'buffet/streetfood bar': { label: 'Buffet/streetfood bar', fixed: 100, pp: -0.25 },
      'onbeperkt pakket': { label: 'Onbeperkt pakket', fixed: 175, pp: 2.75 },
      'per persoon pakket': { label: 'Per persoon pakket', fixed: 75, pp: 0 },
      'verkoop op munten/tickets': { label: 'Munten/tickets', fixed: 75, pp: 0 },
      'festivalverkoop aan bezoekers': { label: 'Festivalverkoop', fixed: 250, pp: 0, visitorPays: true }
    };

    var conceptPrices = {
      'budget friet/snack basis': { label: 'Budget friet/snack basis', pp: 0, fixed: 0 },
      'loaded fries bar': { label: 'Loaded Fries Bar', pp: 0.95, fixed: 0 },
      'smashburgers': { label: 'Smashburgers', pp: 1.75, fixed: 0 },
      'asian streetfood': { label: 'Asian Streetfood', pp: 2, fixed: 0 },
      'juice & smoothie bar': { label: 'Juice & Smoothie Bar', pp: 1.75, fixed: 0 },
      'mix & match': { label: 'Mix & Match', pp: 1.5, fixed: 0 },
      'premium event menu': { label: 'Premium event menu', pp: 3.5, fixed: 100 },
      'wij denken mee': { label: 'Wij denken mee', pp: 0, fixed: 0 }
    };

    var extraPrices = {
      'vegetarische opties': { label: 'Vegetarische opties', pp: 0, fixed: 0 },
      'vegan opties': { label: 'Vegan opties', pp: 0.35, fixed: 0 },
      'halal-vriendelijke opties waar mogelijk': { label: 'Halal-vriendelijke opties', pp: 0.25, fixed: 0 },
      'smoothies/dranken': { label: 'Smoothies/dranken', pp: 1.95, fixed: 0 },
      'dessert/snacks': { label: 'Dessert/snacks', pp: 1.5, fixed: 0 },
      'personeelslunch': { label: 'Personeelslunch', pp: 2.95, fixed: 0 },
      'late-night snack': { label: 'Late-night snack', pp: 2.25, fixed: 0 },
      'extra uitgiftepunt': { label: 'Extra uitgiftepunt', pp: 0, fixed: 150 },
      'tweede wagen/bar': { label: 'Tweede wagen/bar', pp: 0, fixed: 350 },
      'tv-menu/branding op locatie': { label: 'TV-menu/branding', pp: 0, fixed: 50 },
      'bedrijfslogo op scherm/menu mogelijk': { label: 'Bedrijfslogo op scherm/menu', pp: 0, fixed: 35 }
    };

    if (!guests) {
      return {
        label: 'Vul het aantal gasten in',
        detail: 'Vul het aantal gasten in. De budgetbasis staat alvast klaar, daarna bouw je uit.' + (eventAdditions.length ? ' Karaoke en extra techniek worden apart geoffreerd.' : ''),
        lines: [],
        note: '* Richtprijs exclusief btw en exclusief eventuele reiskosten, stroomvoorziening of locatiespecifieke kosten. Definitieve offerte stemmen we netjes af.',
        hidden: 'Nog geen prijsindicatie: aantal gasten ontbreekt.'
      };
    }

    var selectedPackage = packages[packageKey] || packages.standard;
    var selectedService = services[serviceKey] || services['foodtruck op locatie'];
    var fixed = selectedService.fixed;
    var perPerson = selectedPackage.pp + selectedService.pp;
    var minimum = selectedPackage.minimum;

    if (eventType.indexOf('bedrijfsfeest') >= 0) minimum = Math.max(minimum, 350);
    if (eventType.indexOf('festival') >= 0) {
      minimum = Math.max(minimum, 350);
      notes.push('Festivalprijzen hangen ook af van standgeld, munten/tickets en bezoekersstroom.');
    }
    if (eventType.indexOf('sportevent') >= 0 || eventType.indexOf('beurs') >= 0) fixed += 50;
    if (guests >= 300) fixed += 100;

    lines.push('Service/opstart: ' + euro(selectedService.fixed));
    lines.push(selectedPackage.label + ': ' + euroPerPerson(selectedPackage.pp) + ' p.p.');

    state.concepts.forEach(function (concept) {
      var price = conceptPrices[normalize(concept)];
      if (!price) return;
      perPerson += price.pp;
      fixed += price.fixed;
      if (price.pp || price.fixed) {
        lines.push(price.label + ': ' + formatPriceParts(price));
      } else {
        lines.push(price.label + ': inbegrepen');
      }
    });

    state.extras.forEach(function (extra) {
      var price = extraPrices[normalize(extra)];
      if (!price) return;
      perPerson += price.pp;
      fixed += price.fixed;
      if (price.pp || price.fixed) {
        lines.push(price.label + ': ' + formatPriceParts(price));
      }
    });

    if (selectedService.visitorPays) {
      perPerson = 0;
      minimum = Math.max(minimum, 350);
      notes.push('Bij festivalverkoop aan bezoekers werken we vaak met standplaats, omzetafspraak of garantiebedrag in plaats van catering per persoon.');
    }

    var subtotal = fixed + guests * perPerson;
    var total = roundUp(Math.max(subtotal, minimum), 25);
    var calculatedPerPerson = total / guests;

    if (total === minimum && subtotal < minimum) {
      lines.push('Minimum voor deze opzet: ' + euro(minimum));
    } else {
      lines.unshift('Aantal gasten: ' + guests + ' x ca. ' + euroPerPerson(perPerson));
      lines.push('Vaste kosten/opzet totaal: ' + euro(fixed));
    }

    if (packageKey === 'custom') {
      notes.push('Custom wordt altijd nagebeld, maar deze richtprijs geeft alvast een realistisch startpunt.');
    }
    if (guests >= 500) {
      notes.push('Bij 500+ gasten checken we capaciteit, crew en uitgiftepunten altijd apart.');
    }
    if (serviceKey.indexOf('munten') >= 0 || serviceKey.indexOf('festivalverkoop') >= 0) {
      notes.push('Bij verkoop aan bezoekers kan de afspraak afwijken door omzetverwachting, fee of muntenregeling.');
    }

    var note = '* Richtprijs exclusief btw en exclusief eventuele reiskosten, stroomvoorziening, standplaatskosten of locatiespecifieke kosten. We houden de offerte praktisch en kunnen waar nodig nog bijsturen op menu, aantallen en opstelling.';
    if (notes.length) note += ' ' + notes.join(' ');
    if (eventAdditions.length) {
      note += ' Niet inbegrepen in deze cateringrichtprijs: ' + eventAdditions.join(', ') + '. Hiervoor ontvang je een aparte prijs; pas de volledige offerte vormt jouw totaalvoorstel.';
      eventAdditions.forEach(function (item) { lines.push(item + ': apart op aanvraag, niet in cateringprijs'); });
    }

    var detail = selectedService.visitorPays
      ? 'Bij bezoekersverkoop rekenen we meestal met standplaats, omzetafspraak of garantie in plaats van een vaste prijs per gast.'
      : 'Ca. ' + euroPerPerson(calculatedPerPerson) + ' p.p. inclusief gekozen opzet.';
    var hiddenPerPerson = selectedService.visitorPays
      ? 'Prijs per persoon: niet van toepassing bij bezoekersverkoop'
      : 'Prijs per persoon: ca. ' + euroPerPerson(calculatedPerPerson);

    return {
      total: total,
      label: (eventAdditions.length ? 'Cateringrichtprijs ' : 'Richtprijs ') + euro(total) + '*',
      detail: detail,
      lines: lines,
      note: note,
      hidden: [
        'Richtprijs: ' + euro(total) + '*',
        hiddenPerPerson,
        'Prijsopbouw: ' + lines.join(' | '),
        'Voorbehoud: ' + note.replace('* ', '')
      ].join('\n')
    };
  }

  function canonicalKaraoke(value) {
    var aliases = {
      'self': 'self', 'zelf zingen': 'self', 'zelfbediening': 'self',
      'party': 'party', 'karaoke party': 'party', 'met begeleiding': 'party',
      'evening': 'evening', 'karaoke avond': 'evening',
      'advice': 'advice', 'wij denken mee': 'advice', 'advies': 'advice',
      'none': 'none', 'geen karaoke': 'none'
    };
    return aliases[normalizeChoice(value)] || '';
  }

  function canonicalDrink(value) {
    var aliases = {
      'cocktails': 'Cocktailbar', 'cocktailbar': 'Cocktailbar',
      'mocktails': 'Alcoholvrije cocktails', 'alcoholvrije cocktails': 'Alcoholvrije cocktails',
      'borrelservice': 'Bier, wijn & borrelservice', 'bier wijn en borrelservice': 'Bier, wijn & borrelservice'
    };
    return aliases[normalizeChoice(value)] || value;
  }

  function wantsAlcohol(state) {
    return (state.drinks || []).some(function (drink) {
      return drink === 'Cocktailbar' || drink === 'Bier, wijn & borrelservice';
    });
  }

  function alcoholConditions() {
    return 'Alcoholservice pas bevestigd na controle van de vergunning of ontheffing voor de schenklocatie. Uitsluitend 18+, ID bij twijfel en verantwoord schenken. Assortiment, tijdvak en bezetting vooraf afspreken.';
  }

  function calculateRequestEstimate(state, prices) {
    var solo = state.requestScope === 'Alleen karaoke';
    var catering = solo ? null : calculateEstimate(Object.assign({}, state, {
      requestScope: 'Alleen catering', karaokeMode: 'Geen karaoke', eventModules: []
    }));
    var packageKey = state.karaokePackage || 'none';
    var selected = prices[packageKey];
    var wantsKaraoke = packageKey !== 'none';
    var gross = selected ? Number(selected[solo ? 'solo' : 'combo']) : NaN;
    var vat = Number(prices.vat);
    var hasRate = selected && Number.isFinite(gross) && gross > 0 && Number.isFinite(vat) && vat >= 0;
    var modules = (state.eventModules || []).concat(state.drinks || []);
    if (!wantsKaraoke && !modules.length && !solo) return catering;

    // Karaoke card prices include VAT; the existing catering amount excludes VAT.
    var karaokeNet = hasRate ? Math.round(gross / (1 + vat / 100) * 100) / 100 : 0;
    var hasCateringPrice = catering && Number.isFinite(catering.total);
    var totalNet = (hasCateringPrice ? catering.total : 0) + karaokeNet;
    var lines = hasCateringPrice ? ['Catering: ' + euroPerPerson(catering.total) + ' excl. btw'].concat(catering.lines) : [];
    var label;
    var detail;
    var note = '* ';
    if (wantsKaraoke || solo) note += 'De gekozen karaoke vindt plaats bij onze foodtruck. ';
    if (hasRate) {
      lines.push(selected.label + ' (' + selected.hours + ' uur, ' + selected.mode + '): ' + euro(gross) + ' incl. btw (' + euroPerPerson(karaokeNet) + ' excl. ' + vat + '% btw).');
      if (solo) {
        label = (modules.length ? 'Basisrichtprijs ' : 'Richtprijs ') + euro(gross) + ' incl. btw*';
        detail = selected.label + ', ' + selected.hours + ' uur, met de foodtruck. Geen eten of drinken inbegrepen.';
      } else if (hasCateringPrice) {
        label = (modules.length ? 'Basisrichtprijs ' : 'Richtprijs ') + euroPerPerson(totalNet) + ' excl. btw*';
        detail = 'Catering ' + euro(catering.total) + ' excl. btw + karaoke ' + euro(gross) + ' incl. btw. Het totaal hierboven is exclusief btw; de btw op de catering wordt in je offerte uitgesplitst.';
      } else {
        label = 'Karaoke ' + euro(gross) + ' incl. btw*';
        detail = 'Karaoke staat klaar. Vul het aantal gasten in voor de cateringprijs en de volledige richtprijs.';
      }
    } else {
      if (wantsKaraoke) lines.push('Karaoke: pakket en prijs op aanvraag.');
      label = hasCateringPrice ? (wantsKaraoke ? 'Catering ' : 'Basisrichtprijs ') + euro(catering.total) + ' excl. btw*' : (wantsKaraoke || solo ? 'Karaokeprijs op aanvraag' : catering.label);
      detail = wantsKaraoke ? 'Kies een karaokepakket voor een directe pakketprijs, of laat ons meedenken. Karaoke is nog niet in het getoonde cateringbedrag opgenomen.' : (catering ? catering.detail : 'Kies een karaokepakket.');
    }
    if (solo) {
      note += 'Vervoer binnen ' + prices.radius + ' km van Ommen inbegrepen; daarbuiten rekenen we reiskosten vooraf uit. ';
    } else if (wantsKaraoke) {
      note += 'De combinatieprijs geldt binnen de al geboekte truckaanwezigheid. Langer blijven wordt vooraf geoffreerd. Catering en eventuele reiskosten worden apart uitgesplitst. ';
    }
    if (wantsKaraoke || solo) note += 'Pakket inclusief bestaande truckopstelling, karaokegeluid, opbouw en uitleg. Vooraf bevestigen we beschikbaarheid, bereikbaarheid, stroom en een veilige opstelling. Verlenging en extra techniek zijn niet inbegrepen; je krijgt eerst een heldere offerte.';
    if (modules.length) {
      lines = lines.concat(modules.map(function (module) { return module + ': apart op aanvraag, niet in de basisrichtprijs.'; }));
      note += ' Niet inbegrepen in de getoonde basis: ' + modules.join(', ') + '.';
    }
    if ((state.drinks || []).length) note += ' Drankservice wordt apart geoffreerd op basis van assortiment, tijdvak, aantallen en personeel.';
    if (wantsAlcohol(state)) note += ' ' + alcoholConditions();
    if (catering && hasCateringPrice) note += ' ' + catering.note.replace(/^\*\s*/, '');
    return {
      total: solo ? (hasRate ? gross : undefined) : (hasCateringPrice ? Math.round(totalNet * 100) / 100 : undefined),
      karaokeGross: hasRate ? gross : undefined,
      karaokeNet: hasRate ? karaokeNet : undefined,
      label: label, detail: detail, lines: lines, note: note,
      hidden: [label, detail, 'Prijsopbouw: ' + lines.join(' | '), 'Voorbehoud: ' + note].join('\n')
    };
  }

  function buildSummary(state) {
    return [
      'Soort aanvraag: ' + (state.requestScope || 'Alleen catering'),
      'Type event: ' + (state.eventType || 'Nog niet gekozen'),
      'Aantal personen: ' + (state.guests || 'Nog niet ingevuld'),
      'Datum: ' + (state.date || 'Nog niet ingevuld'),
      'Tijd: ' + [state.startTime, state.endTime].filter(Boolean).join(' - '),
      'Locatie: ' + (state.location || 'Nog niet ingevuld'),
      'Concepten: ' + (state.concepts.length ? state.concepts.join(', ') : 'Nog niet gekozen'),
      'Servicevorm: ' + (state.service || 'Nog niet gekozen'),
      'Pakketniveau: ' + (state.packageLevel || 'Nog niet gekozen'),
      'Extra opties: ' + (state.extras.length ? state.extras.join(', ') : 'Geen extra opties gekozen'),
      'Karaoke: ' + (state.karaokeMode || 'Geen karaoke'),
      'Karaokepakket: ' + (state.karaokePackageLabel || 'Geen pakket gekozen'),
      'Inbegrepen karaoke-uren: ' + (state.karaokeHours || 'Nog te bepalen'),
      'Karaoke pakketprijs: ' + (Number.isFinite(state.estimate.karaokeGross) ? euro(state.estimate.karaokeGross) + ' incl. btw, per feest' : 'Geen vast bedrag gekozen'),
      'Karaoke tijdvak: ' + (state.karaokeTime || 'Nog te bepalen'),
      'Extra eventvoorzieningen: ' + ((state.eventModules || []).join(', ') || 'Geen'),
      'Drankservice: ' + ((state.drinks || []).join(', ') || 'Geen'),
      'Drankafspraak: ' + (state.drinksPlan || 'Niet van toepassing'),
      'Drankservice tijdvak: ' + (state.drinksTime || 'Niet ingevuld'),
      'Aantal gasten 18+: ' + (state.adultGuests || 'Niet ingevuld'),
      'Vergunningstatus volgens aanvrager: ' + (state.permitStatus || 'Niet van toepassing'),
      'Alcoholservice voorbehoud: ' + (wantsAlcohol(state) ? alcoholConditions() : 'Geen alcoholservice geselecteerd'),
      'Binnen of buiten: ' + (state.eventSetting || 'Nog te bepalen'),
      'Stroom/apparatuur op locatie: ' + (state.siteFacilities || 'Nog te bespreken'),
      'Naam: ' + (state.name || 'Nog niet ingevuld'),
      'Bedrijf: ' + (state.company || 'Niet ingevuld'),
      'E-mail: ' + (state.email || 'Nog niet ingevuld'),
      'Telefoon: ' + (state.phone || 'Niet ingevuld'),
      'Bericht: ' + (state.message || 'Geen extra bericht'),
      'Indicatieve prijs: ' + state.estimate.label,
      'Prijsopbouw: ' + state.estimate.lines.join(' | '),
      'Prijsvoorbehoud: ' + state.estimate.note
    ].join('\n');
  }

  function getParamChoices(params, names) {
    var values = [];
    names.forEach(function (name) {
      params.getAll(name).forEach(function (value) {
        String(value || '')
          .split(/[|,]/)
          .map(function (item) { return item.trim(); })
          .filter(Boolean)
          .forEach(function (item) { values.push(item); });
      });
    });
    return values;
  }

  function selectByValues(root, key, values, canonicalizer) {
    if (!values.length) return;
    var normalizedValues = values.map(function (value) {
      return normalizeChoice(canonicalizer ? canonicalizer(value) : value);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-config-input="' + key + '"]'), function (input) {
      var inputValue = normalizeChoice(input.value);
      if (normalizedValues.indexOf(inputValue) >= 0) {
        input.checked = true;
      }
    });
  }

  function applyUrlSelections(root) {
    if (!window.URLSearchParams) return;
    var params = new URLSearchParams(window.location.search);
    selectByValues(root, 'concepts', getParamChoices(params, ['concept', 'concepts']), canonicalConcept);
    selectByValues(root, 'eventType', getParamChoices(params, ['event', 'eventType']));
    selectByValues(root, 'service', getParamChoices(params, ['service']));
    selectByValues(root, 'packageLevel', getParamChoices(params, ['package', 'pakket', 'packageLevel']));
    selectByValues(root, 'requestScope', getParamChoices(params, ['scope']));
    selectByValues(root, 'drinks', getParamChoices(params, ['drinks']), canonicalDrink);
    var drinksPlan = root.querySelector('[data-config-input="drinksPlan"]');
    if (drinksPlan && params.get('drinks_plan') === 'arrangement') drinksPlan.value = 'Arrangement in afgesproken tijdvak';
    var karaokeInput = root.querySelector('[data-config-input="karaokePackage"]');
    var requestedKaraoke = canonicalKaraoke(params.get('karaoke_package') || params.get('karaokepakket') || params.get('karaoke'));
    if (karaokeInput && requestedKaraoke) {
      Array.prototype.forEach.call(karaokeInput.options, function (option) {
        if (normalizeChoice(option.value) === normalizeChoice(requestedKaraoke)) karaokeInput.value = option.value;
      });
    }
    var requestedGuests = Number(params.get('guests'));
    var guestsInput = root.querySelector('[data-config-input="guests"]');
    if (guestsInput && Number.isInteger(requestedGuests) && requestedGuests > 0 && requestedGuests <= 10000) {
      guestsInput.value = String(requestedGuests);
    }
  }

  function setupFriesEstimate(root) {
    var guestsInput = root.querySelector('[data-fries-guests]');
    var eventInput = root.querySelector('[data-fries-event]');
    var price = root.querySelector('[data-fries-price]');
    var detail = root.querySelector('[data-fries-price-detail]');
    var breakdown = root.querySelector('[data-fries-breakdown]');
    var quote = root.querySelector('[data-fries-quote]');
    if (!guestsInput || !eventInput || !price || !detail || !breakdown || !quote) return;

    function renderFriesEstimate() {
      var guests = Number(guestsInput.value);
      if (!Number.isInteger(guests) || guests < 1 || guests > 10000) {
        price.textContent = 'Vul het aantal gasten in';
        detail.textContent = 'Kies een heel aantal tussen 1 en 10.000.';
        breakdown.innerHTML = '';
        quote.href = '/pages/catering-samenstellen?concept=Budget+friet%2Fsnack+basis&package=Budget%2Fbasic&service=Foodtruck+op+locatie';
        return;
      }
      // Both calculators use the existing pricing rules, including minimum and setup.
      var estimate = calculateEstimate({
        guests: guests,
        eventType: eventInput.value,
        service: 'Foodtruck op locatie',
        packageLevel: 'Budget/basic',
        concepts: ['Budget friet/snack basis'],
        extras: []
      });
      price.textContent = estimate.label;
      detail.textContent = estimate.detail;
      breakdown.innerHTML = estimate.lines.map(function (line) {
        return '<li>' + escapeHtml(line) + '</li>';
      }).join('');
      var params = new URLSearchParams({
        concept: 'Budget friet/snack basis',
        package: 'Budget/basic',
        service: 'Foodtruck op locatie',
        event: eventInput.value,
        guests: String(guests)
      });
      quote.href = '/pages/catering-samenstellen?' + params.toString();
    }

    guestsInput.addEventListener('input', renderFriesEstimate);
    eventInput.addEventListener('change', renderFriesEstimate);
    renderFriesEstimate();
  }

  function setDateMinimum(root) {
    var dateInput = root.querySelector('[data-config-input="date"]');
    if (!dateInput || dateInput.min) return;
    var today = new Date();
    today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
    dateInput.min = today.toISOString().slice(0, 10);
  }

  function setupConfigurator(root) {
    var form = root.querySelector('[data-config-form]') || root.querySelector('form');
    var summary = root.querySelector('[data-config-summary]');
    var price = root.querySelector('[data-config-price]');
    var priceDetail = root.querySelector('[data-config-price-detail]');
    var priceBreakdown = root.querySelector('[data-config-price-breakdown]');
    var priceNote = root.querySelector('[data-config-price-note]');
    var errors = root.querySelector('[data-config-errors]');
    if (!form || !summary || !price) return;
    var karaokePrices = {};
    var pricesElement = root.querySelector('[data-karaoke-prices]');
    try { karaokePrices = JSON.parse(pricesElement ? pricesElement.textContent : '{}'); } catch (error) { karaokePrices = {}; }

    function readState() {
      var requestScope = getCheckedValue(root, 'requestScope') || 'Alleen catering';
      var karaokeOnly = requestScope === 'Alleen karaoke';
      var state = {
        requestScope: requestScope,
        eventType: getCheckedValue(root, 'eventType'),
        guests: getValue(root, 'guests'),
        date: getValue(root, 'date'),
        startTime: getValue(root, 'startTime'),
        endTime: getValue(root, 'endTime'),
        location: getValue(root, 'location'),
        concepts: karaokeOnly ? [] : getCheckedValues(root, 'concepts'),
        service: karaokeOnly ? '' : getCheckedValue(root, 'service'),
        packageLevel: karaokeOnly ? '' : getCheckedValue(root, 'packageLevel'),
        extras: karaokeOnly ? [] : getCheckedValues(root, 'extras'),
        karaokePackage: getValue(root, 'karaokePackage') || 'none',
        karaokeTime: getValue(root, 'karaokeTime'),
        eventModules: getCheckedValues(root, 'eventModules'),
        drinks: getCheckedValues(root, 'drinks'),
        eventSetting: getValue(root, 'eventSetting'),
        siteFacilities: getValue(root, 'siteFacilities'),
        name: getValue(root, 'name'),
        company: getValue(root, 'company'),
        email: getValue(root, 'email'),
        phone: getValue(root, 'phone'),
        message: getValue(root, 'message')
      };
      var selectedKaraoke = karaokePrices[state.karaokePackage];
      state.karaokeMode = selectedKaraoke ? selectedKaraoke.mode : (state.karaokePackage === 'none' ? 'Geen karaoke' : 'Wij denken mee');
      state.karaokePackageLabel = selectedKaraoke ? selectedKaraoke.label : (state.karaokePackage === 'none' ? 'Geen karaoke' : 'Wij denken mee');
      state.karaokeHours = selectedKaraoke ? selectedKaraoke.hours : '';
      state.drinksPlan = state.drinks.length ? getValue(root, 'drinksPlan') : '';
      state.drinksTime = state.drinks.length ? getValue(root, 'drinksTime') : '';
      state.adultGuests = wantsAlcohol(state) ? getValue(root, 'adultGuests') : '';
      state.permitStatus = wantsAlcohol(state) ? getValue(root, 'permitStatus') : '';
      state.estimate = calculateRequestEstimate(state, karaokePrices);
      state.summary = buildSummary(state);
      return state;
    }

    function setHidden(name, value) {
      var input = form.querySelector('[data-config-hidden="' + name + '"]');
      if (input) input.value = value || '';
    }

    function render() {
      var state = readState();
      var karaokeOnly = state.requestScope === 'Alleen karaoke';
      Array.prototype.forEach.call(root.querySelectorAll('[data-catering-only]'), function (group) {
        group.hidden = karaokeOnly;
        if (group.tagName === 'FIELDSET') group.disabled = karaokeOnly;
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-catering-pricing]'), function (group) { group.hidden = karaokeOnly; });
      var eventDetails = root.querySelector('[data-event-details]');
      if (eventDetails) eventDetails.hidden = state.requestScope === 'Alleen catering' && state.karaokeMode === 'Geen karaoke' && !state.eventModules.length;
      var drinksDetails = root.querySelector('[data-drinks-details]');
      var alcoholDetails = root.querySelector('[data-alcohol-details]');
      if (drinksDetails) drinksDetails.hidden = !state.drinks.length;
      if (alcoholDetails) alcoholDetails.hidden = !wantsAlcohol(state);
      Array.prototype.forEach.call(root.querySelectorAll('[data-drinks-details] input, [data-drinks-details] select'), function (input) {
        input.disabled = !state.drinks.length || (input.closest('[data-alcohol-details]') && !wantsAlcohol(state));
      });
      var summaryRows = [
        ['Soort aanvraag', state.requestScope],
        ['Type event', state.eventType || 'Nog niet gekozen'],
        ['Aantal personen', state.guests || 'Nog niet ingevuld'],
        ['Datum en tijd', [state.date, state.startTime, state.endTime].filter(Boolean).join(' | ') || 'Nog niet ingevuld'],
        ['Locatie', state.location || 'Nog niet ingevuld'],
        ['Concepten', state.concepts.length ? state.concepts.join(', ') : 'Nog niet gekozen'],
        ['Servicevorm', state.service || 'Nog niet gekozen'],
        ['Pakketniveau', state.packageLevel || 'Nog niet gekozen'],
        ['Extra opties', state.extras.length ? state.extras.join(', ') : 'Geen extra opties gekozen']
      ];
      if (karaokeOnly) summaryRows = summaryRows.filter(function (row) {
        return ['Concepten', 'Servicevorm', 'Pakketniveau', 'Extra opties'].indexOf(row[0]) < 0;
      });
      if (state.karaokeMode !== 'Geen karaoke' || state.requestScope !== 'Alleen catering' || state.eventModules.length) {
        summaryRows.push(['Karaokepakket', state.karaokePackageLabel + (state.karaokeHours ? ' - ' + state.karaokeHours + ' uur' : '')], ['Karaokevorm', state.karaokeMode], ['Karaoke tijdvak', state.karaokeTime || 'Nog te bepalen'], ['Extra techniek', state.eventModules.join(', ') || 'Geen'], ['Binnen/buiten', state.eventSetting]);
      }
      if (state.drinks.length) {
        summaryRows.push(['Drankservice (apart geoffreerd)', state.drinks.join(', ')], ['Drankafspraak', state.drinksPlan], ['Drankservice tijdvak', state.drinksTime || 'Nog te bepalen']);
        if (wantsAlcohol(state)) summaryRows.push(['Gasten 18+', state.adultGuests || 'Nog te bepalen'], ['Vergunningstatus', state.permitStatus]);
      }
      var karaokeHint = root.querySelector('[data-karaoke-price-hint]');
      if (karaokeHint) karaokeHint.textContent = Number.isFinite(state.estimate.karaokeGross) ? state.karaokePackageLabel + ': ' + euro(state.estimate.karaokeGross) + ' incl. btw per feest (' + state.karaokeHours + ' uur).' : (state.karaokePackage === 'none' ? 'Geen karaoke toegevoegd.' : 'Wij bespreken een passend pakket en de prijs met je.');

      summary.innerHTML = summaryRows
        .map(function (row) {
          return '<dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd>';
        })
        .join('');

      price.textContent = state.estimate.label;
      if (priceDetail) priceDetail.textContent = state.estimate.detail;
      if (priceBreakdown) {
        priceBreakdown.innerHTML = state.estimate.lines
          .map(function (line) {
            return '<li>' + escapeHtml(line) + '</li>';
          })
          .join('');
      }
      if (priceNote) priceNote.textContent = state.estimate.note;
      setHidden('eventType', state.eventType);
      setHidden('guests', state.guests);
      setHidden('date', state.date);
      setHidden('startTime', state.startTime);
      setHidden('endTime', state.endTime);
      setHidden('location', state.location);
      setHidden('concepts', state.concepts.join(', '));
      setHidden('service', state.service);
      setHidden('packageLevel', state.packageLevel);
      setHidden('extras', state.extras.join(', '));
      ['requestScope', 'karaokeMode', 'karaokeTime', 'eventSetting', 'siteFacilities'].forEach(function (key) { setHidden(key, state[key]); });
      setHidden('eventModules', state.eventModules.join(', '));
      setHidden('drinks', state.drinks.join(', '));
      ['drinksPlan', 'drinksTime', 'adultGuests', 'permitStatus'].forEach(function (key) { setHidden(key, state[key]); });
      setHidden('alcoholConditions', wantsAlcohol(state) ? alcoholConditions() : 'Geen alcoholservice geselecteerd');
      setHidden('karaokePackage', state.karaokePackageLabel);
      setHidden('karaokeHours', String(state.karaokeHours || ''));
      setHidden('karaokePrice', Number.isFinite(state.estimate.karaokeGross) ? euroPerPerson(state.estimate.karaokeGross) + ' incl. btw' : 'Op aanvraag / niet geselecteerd');
      setHidden('estimate', state.estimate.hidden);
      setHidden('summary', state.summary);
    }

    function validateConfig() {
      var state = readState();
      var messages = [];
      if (!state.eventType) messages.push('Kies het type event.');
      if (!state.guests) messages.push('Vul het aantal personen in.');
      if (!state.date) messages.push('Vul de datum in.');
      if (!state.location) messages.push('Vul de eventlocatie in.');
      if (state.adultGuests && Number(state.adultGuests) > Number(state.guests)) messages.push('Het aantal gasten van 18 jaar en ouder kan niet hoger zijn dan het totale aantal gasten.');
      if (state.requestScope !== 'Alleen karaoke') {
        if (!state.concepts.length) messages.push('Kies minimaal een concept.');
        if (!state.service) messages.push('Kies een servicevorm.');
        if (!state.packageLevel) messages.push('Kies een pakketniveau.');
      }
      if ((state.requestScope === 'Alleen karaoke' || state.requestScope === 'Catering + karaoke') && state.karaokePackage === 'none') messages.push('Kies een karaokepakket of laat ons meedenken.');
      return messages;
    }

    function validateContactFields() {
      var messages = [];
      var labels = {
        ConfigName: 'Vul je naam in.',
        ConfigEmail: 'Vul een geldig e-mailadres in.',
        ConfigDate: 'Vul de datum in.',
        ConfigGuests: 'Vul het aantal personen in.',
        ConfigLocation: 'Vul de eventlocatie in.'
      };
      Array.prototype.forEach.call(form.elements, function (element) {
        if (!element.willValidate || typeof element.checkValidity !== 'function' || element.checkValidity()) return;
        if (labels[element.id]) {
          messages.push(labels[element.id]);
        } else if (element.type === 'checkbox' && element.required) {
          messages.push('Ga akkoord met het privacybeleid.');
        } else if (element.validationMessage) {
          messages.push(element.validationMessage);
        }
      });
      return messages.filter(function (message, index, list) {
        return list.indexOf(message) === index;
      });
    }

    root.addEventListener('input', render);
    function alignRequestScope() {
      var scope = getCheckedValue(root, 'requestScope');
      var karaoke = root.querySelector('[data-config-input="karaokePackage"]');
      if (karaoke && (scope === 'Alleen karaoke' || scope === 'Catering + karaoke') && karaoke.value === 'none') karaoke.value = 'self';
    }

    root.addEventListener('change', function (event) {
      var key = event.target.getAttribute('data-config-input');
      if (key === 'requestScope') {
        if (getCheckedValue(root, 'requestScope') === 'Alleen catering') {
          root.querySelector('[data-config-input="karaokePackage"]').value = 'none';
          Array.prototype.forEach.call(root.querySelectorAll('[data-config-input="eventModules"]'), function (input) { input.checked = false; });
        } else {
          alignRequestScope();
        }
      } else if ((key === 'karaokePackage' && event.target.value !== 'none') || (key === 'eventModules' && event.target.checked)) {
        if (getCheckedValue(root, 'requestScope') === 'Alleen catering') {
          selectByValues(root, 'requestScope', [key === 'eventModules' ? 'Compleet feest' : 'Catering + karaoke']);
        }
      }
      render();
    });

    form.addEventListener('submit', function (event) {
      render();
      var messages = validateConfig().concat(validateContactFields()).filter(function (message, index, list) {
        return list.indexOf(message) === index;
      });
      if (!form.checkValidity() || messages.length) {
        event.preventDefault();
        if (errors) {
          errors.innerHTML = messages.length
            ? '<strong>Controleer je aanvraag:</strong><ul><li>' + messages.map(escapeHtml).join('</li><li>') + '</li></ul>'
            : '';
          errors.hidden = messages.length === 0;
        }
        form.reportValidity();
        if (messages.length) {
          errors.focus();
        }
      }
    });

    setDateMinimum(root);
    applyUrlSelections(root);
    alignRequestScope();
    render();
  }

  onReady(function () {
    setupHeader();
    Array.prototype.forEach.call(document.querySelectorAll('[data-configurator]'), setupConfigurator);
    Array.prototype.forEach.call(document.querySelectorAll('[data-fries-estimate]'), setupFriesEstimate);
  });
})();
